/* Aba Casos. No computador vira tabela; no celular, a mesma lista de cartões do quadro. */
import { $, $$, esc, dataBR, dias, idade } from "../util.js";
import { S, visiveis, captadores } from "../estado.js";
import { MAPA } from "../dados/especies.js";
import { ETAPAS, DOCS } from "../dados/etapas.js";
import { cardHTML, ligarDnD } from "./quadro.js";
import { abrirFicha } from "./ficha.js";

export function renderCasos(){
  const lista=visiveis(MAPA).slice().sort((a,b)=>String(a.entrada||"").localeCompare(String(b.entrada||"")));
  const caps=captadores();
  const ranking=(S.souAdmin&&caps.length)?`<div class="ranking">${caps.map(n=>`<span class="rank-item">${esc(n)}<b>${S.casos.filter(c=>(c.captador||"")===n).length}</b></span>`).join("")}</div>`:"";
  if(!lista.length){
    $("#vCasos").innerHTML=ranking+`<div class="panel"><div class="empty">
      <h3>${S.casos.length?"Nenhum caso com esse filtro":"Nenhum caso registrado"}</h3>
      <p>${S.casos.length?"Limpe a busca para ver todos.":"Cadastre o primeiro cliente para começar o acompanhamento."}</p>
      ${S.casos.length?"":'<button class="btn" id="vazioNovo">+ Novo caso</button>'}</div></div>`;
    if($("#vazioNovo")) $("#vazioNovo").onclick=()=>abrirFicha();
    return;
  }
  if(window.matchMedia("(min-width:761px)").matches){
    $("#vCasos").innerHTML=ranking+`<div class="panel"><div class="tbl-scroll"><table>
      <thead><tr><th>Cliente</th>${S.souAdmin?"<th>Captador</th>":""}<th>Entrada</th><th>Dias</th><th>Caso</th><th>Doc</th><th>Anexos</th><th>Situação</th></tr></thead>
      <tbody>${lista.map(c=>{
        const esp=MAPA[c.codigo],n=dias(c.entrada),d=DOCS[c.doc]||DOCS.nao,et=ETAPAS.find(e=>e.id===c.etapa)||ETAPAS[0];
        return `<tr data-id="${c.id}">
          <td style="font-weight:600">${esc(c.cliente)}</td>
          ${S.souAdmin?`<td>${c.captador?esc(c.captador):'<span style="color:var(--muted)">\u2014</span>'}</td>`:""}
          <td class="mono" style="font-size:12.5px">${dataBR(c.entrada)}</td>
          <td><span class="age ${idade(n)}">${n==null?"\u2014":n}</span></td>
          <td>${c.codigo?`<span class="code${esp&&!esp.ativo?" ext":""}">${c.codigo}</span> `:""}<span style="color:var(--muted)">${esc(esp?esp.nome:"\u2014")}</span></td>
          <td><span class="status-pill"><i class="dot" style="background:${d.cor}"></i>${d.rot.replace("Doc ","")}</span></td>
          <td class="mono" style="font-size:12px">${(c.anexos||[]).length||"\u2014"}</td>
          <td><span class="status-pill"><i class="dot" style="background:${et.cor}"></i>${et.nome}</span></td></tr>`;
      }).join("")}</tbody></table></div></div>`;
    $$("#vCasos tbody tr").forEach(tr=>tr.addEventListener("click",()=>abrirFicha(tr.dataset.id)));
  }else{
    $("#vCasos").innerHTML=ranking+`<div class="lista-mob">${lista.map(cardHTML).join("")}</div>`;
    ligarDnD($("#vCasos"),false);
  }
}
